import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";

const UPDATE_KPIV2_DETAIL = `
	update_kpiv2_detail (
		kpi_v2_id: $kpi_v2_id,
		kpiable_type: $kpiable_type,
		kpiable_id: $kpiable_id,
		maintain_hrs:$maintain_hrs,
		pivot_id:$pivot_id,
		name: $name,
		tag_ids: $tag_ids) {
    	...Kpiv2
	}
`;

const DELETE_KPIV2_DETAIL = `
	delete_kpiv2_detail (id: $id) {
		...Kpiv2
	}
`;

const ADD_KPIV2_ITEM_TO_OBJECT = `
	create_kpiv2_detail(
		kpi_v2_id: $kpi_v2_id,
		name: $name,
		kpiable_type: $kpiable_type,
		kpiable_id: $kpiable_id,
		maintain_hrs:$maintain_hrs,
		tag_ids: $tag_ids) {
		...Kpiv2
	}
`;

const KPISV2_DETAILS = `
	kpisv2_details (limit: $limit, page: $page, kpiable_type: $kpiable_type, kpiable_id: $kpiable_id) {
		total
		per_page
		data {
			...Kpiv2
			current_hrs
		}
	}`;

const CREATE_KPIV2 = `
	create_kpiv2( name: $name,tag_ids: $tag_ids) {
		id
		name 
	}`;

const RESET_DEVICE = `
	reset_device( device_id: $device_id, kpiv2_id: $kpiv2_id, reason: $reason ) {
		id
		name
  	}
`;

export default {
	init() {},

	getKpi(payload) {
		const queryOptions = {
			query: gql`query KpisManagementDetail (
				$limit: Int!,
				$page: Int!,
				$kpiable_type: String,
				$kpiable_id: Int,
			) {
				${KPISV2_DETAILS}
			}
				${fragments.Kpiv2}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				kpiable_type: payload.kpiable_type || null,
				kpiable_id: payload.kpiable_id || null
			}
		};

		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}

		return graphqlClient.query(queryOptions).then(response => {
			return {
				kpi: response.data.kpisv2_details.data,
				total: response.data.kpisv2_details.total
			};
		});
	},

	addKpiv2ToObject(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation KpisManagementCreateKpiDetail (
					$name: String!,
					$kpiable_id: Int!,
					$kpiable_type: String!,
					$maintain_hrs: Int!,
					$tag_ids: [Int],
					$kpi_v2_id: Int
					) {
						${ADD_KPIV2_ITEM_TO_OBJECT}
					}
					${fragments.Kpiv2}
				`,
				variables: {
					name: payload.name || "",
					kpiable_id: payload.kpiable_id || null,
					kpiable_type: payload.kpiable_type || null,
					maintain_hrs: payload.maintain_hrs || null,
					tag_ids: payload.tag_ids || [],
					kpi_v2_id: payload.kpi_v2_id || null
				}
			})
			.then(response => response.data.create_kpiv2_detail);
	},

	updateKpiv2ToObject(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation KpisManagementUpdateKpiDetail (
					$kpi_v2_id: Int!,
					$kpiable_id: Int!,
					$kpiable_type: String!,
					$maintain_hrs: Int!,
					$pivot_id: Int!,
					$name: String!,
					$tag_ids: [Int]
					) {
						${UPDATE_KPIV2_DETAIL}
					}
					${fragments.Kpiv2}
				`,
				variables: {
					kpi_v2_id: payload.kpi_v2_id || null,
					kpiable_id: payload.kpiable_id || null,
					kpiable_type: payload.kpiable_type || null,
					maintain_hrs: payload.maintain_hrs || null,
					pivot_id: payload.pivot_id || null,
					name: payload.name || "",
					tag_ids: payload.tag_ids || []
				}
			})
			.then(response => response.data.update_kpiv2_detail);
	},

	deleteKpiDetail(kpiDetailId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation KpisManagementDeleteKpiDetail ($id: Int!) {
				${DELETE_KPIV2_DETAIL}
			}
			${fragments.Kpiv2}
			`,
				variables: {
					id: kpiDetailId
				}
			})
			.then(response => response.delete_kpiv2_detail);
	},
	createKpiv2(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation KpisManagementCreateKpiDetail (
					$name: String!,
					$tag_ids: [Int]
					) {
						${CREATE_KPIV2}
					}
				`,
				variables: {
					name: payload.name || "",
					tag_ids: payload.tag_ids || []
				}
			})
			.then(response => response.data.create_kpiv2);
	},
	resetDevice(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ResetDeviceKpi (
					$reason: String!,
					$device_id: Int!,
					$kpiv2_id: Int!
					) {
						${RESET_DEVICE}
					}
				`,
				variables: {
					reason: payload.reason || "",
					device_id: payload.device_id || null,
					kpiv2_id: payload.kpiv2_id || null
				}
			})
			.then(response => response.data.reset_device);
	}
};
